// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"211":"727973242bb33abd","888":"6ae659249462465c"}[chunkId] + ".css";
};